var cov_2r6760kwee = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Select/group.tsx",
      hash = "6e7e59c3d5c66364a007c072aae42269bb137262",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Select/group.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 59,
          column: 3
        }
      },
      "1": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 18
        }
      },
      "2": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 21,
          column: 7
        }
      },
      "3": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 52
        }
      },
      "4": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 33
        }
      },
      "5": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 24
        }
      },
      "6": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 64
        }
      },
      "7": {
        start: {
          line: 31,
          column: 46
        },
        end: {
          line: 31,
          column: 64
        }
      },
      "8": {
        start: {
          line: 35,
          column: 32
        },
        end: {
          line: 35,
          column: 42
        }
      },
      "9": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 40,
          column: 7
        }
      },
      "10": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 31
        }
      },
      "11": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 14
        }
      },
      "12": {
        start: {
          line: 42,
          column: 53
        },
        end: {
          line: 42,
          column: 55
        }
      },
      "13": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 48,
          column: 8
        }
      },
      "14": {
        start: {
          line: 45,
          column: 18
        },
        end: {
          line: 45,
          column: 44
        }
      },
      "15": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 46,
          column: 93
        }
      },
      "16": {
        start: {
          line: 46,
          column: 27
        },
        end: {
          line: 46,
          column: 93
        }
      },
      "17": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 28
        }
      },
      "18": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 52,
          column: 8
        }
      },
      "19": {
        start: {
          line: 51,
          column: 55
        },
        end: {
          line: 51,
          column: 113
        }
      },
      "20": {
        start: {
          line: 56,
          column: 42
        },
        end: {
          line: 56,
          column: 52
        }
      },
      "21": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 82
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 16
          },
          end: {
            line: 9,
            column: 17
          }
        },
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        },
        loc: {
          start: {
            line: 17,
            column: 59
          },
          end: {
            line: 24,
            column: 5
          }
        },
        line: 17
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        },
        loc: {
          start: {
            line: 26,
            column: 24
          },
          end: {
            line: 28,
            column: 5
          }
        },
        line: 26
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 5
          }
        },
        loc: {
          start: {
            line: 30,
            column: 70
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 30
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        },
        loc: {
          start: {
            line: 34,
            column: 18
          },
          end: {
            line: 53,
            column: 5
          }
        },
        line: 34
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 44,
            column: 19
          },
          end: {
            line: 44,
            column: 20
          }
        },
        loc: {
          start: {
            line: 44,
            column: 29
          },
          end: {
            line: 48,
            column: 7
          }
        },
        line: 44
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 51,
            column: 44
          },
          end: {
            line: 51,
            column: 45
          }
        },
        loc: {
          start: {
            line: 51,
            column: 55
          },
          end: {
            line: 51,
            column: 113
          }
        },
        line: 51
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        },
        loc: {
          start: {
            line: 55,
            column: 13
          },
          end: {
            line: 58,
            column: 5
          }
        },
        line: 55
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 64
          }
        }, {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 64
          }
        }],
        line: 31
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 40,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 40,
            column: 7
          }
        }, {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 40,
            column: 7
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 46,
            column: 93
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 46,
            column: 93
          }
        }, {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 46,
            column: 93
          }
        }],
        line: 46
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 37
          },
          end: {
            line: 46,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 37
          },
          end: {
            line: 46,
            column: 38
          }
        }, {
          start: {
            line: 46,
            column: 42
          },
          end: {
            line: 46,
            column: 44
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 46,
            column: 49
          },
          end: {
            line: 46,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 46,
            column: 53
          },
          end: {
            line: 46,
            column: 77
          }
        }, {
          start: {
            line: 46,
            column: 80
          },
          end: {
            line: 46,
            column: 82
          }
        }],
        line: 46
      },
      "5": {
        loc: {
          start: {
            line: 51,
            column: 55
          },
          end: {
            line: 51,
            column: 113
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 51,
            column: 59
          },
          end: {
            line: 51,
            column: 88
          }
        }, {
          start: {
            line: 51,
            column: 91
          },
          end: {
            line: 51,
            column: 113
          }
        }],
        line: 51
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Select/group.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { getUidStr } from '../utils/uid';
export default (function (Origin) {
  var _class, _temp;

  cov_2r6760kwee.f[0]++;
  cov_2r6760kwee.s[0]++;
  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Group, _React$Component);

    var _super = _createSuper2(Group);

    function Group(props) {
      var _this;

      _classCallCheck(this, Group);

      cov_2r6760kwee.f[1]++;
      cov_2r6760kwee.s[1]++;
      _this = _super.call(this, props);
      _this.groupKey = void 0;
      cov_2r6760kwee.s[2]++;
      _this.state = {
        data: []
      };
      cov_2r6760kwee.s[3]++;
      _this.groupByData = _this.groupByData.bind(_assertThisInitialized(_this));
      cov_2r6760kwee.s[4]++;
      _this.groupKey = getUidStr();
      return _this;
    }

    _createClass(Group, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        cov_2r6760kwee.f[2]++;
        cov_2r6760kwee.s[5]++;
        this.groupByData();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        cov_2r6760kwee.f[3]++;
        cov_2r6760kwee.s[6]++;

        if (prevProps.data !== this.props.data) {
          cov_2r6760kwee.b[0][0]++;
          cov_2r6760kwee.s[7]++;
          this.groupByData();
        } else {
          cov_2r6760kwee.b[0][1]++;
        }
      }
    }, {
      key: "groupByData",
      value: function groupByData() {
        var _this2 = this;

        cov_2r6760kwee.f[4]++;

        var _ref = (cov_2r6760kwee.s[8]++, this.props),
            groupBy = _ref.groupBy,
            data = _ref.data;

        cov_2r6760kwee.s[9]++;

        if (typeof groupBy !== 'function') {
          cov_2r6760kwee.b[1][0]++;
          cov_2r6760kwee.s[10]++;
          this.setState({
            data: data
          });
          cov_2r6760kwee.s[11]++;
          return;
        } else {
          cov_2r6760kwee.b[1][1]++;
        }

        var groupData = (cov_2r6760kwee.s[12]++, {});
        cov_2r6760kwee.s[13]++;
        data.forEach(function (d, i) {
          cov_2r6760kwee.f[5]++;
          var g = (cov_2r6760kwee.s[14]++, groupBy(d, i, data));
          cov_2r6760kwee.s[15]++;

          if (!groupData[g]) {
            cov_2r6760kwee.b[2][0]++;
            cov_2r6760kwee.s[16]++;
            groupData[(cov_2r6760kwee.b[3][0]++, g) || (cov_2r6760kwee.b[3][1]++, '')] = g ? (cov_2r6760kwee.b[4][0]++, [_defineProperty({}, _this2.groupKey, g)]) : (cov_2r6760kwee.b[4][1]++, []);
          } else {
            cov_2r6760kwee.b[2][1]++;
          }

          cov_2r6760kwee.s[17]++;
          groupData[g].push(d);
        });
        cov_2r6760kwee.s[18]++;
        this.setState({
          data: Object.keys(groupData).reduce(function (p, v) {
            cov_2r6760kwee.f[6]++;
            cov_2r6760kwee.s[19]++;
            return v ? (cov_2r6760kwee.b[5][0]++, p.concat(groupData[v])) : (cov_2r6760kwee.b[5][1]++, groupData[v].concat(p));
          }, [])
        });
      }
    }, {
      key: "render",
      value: function render() {
        cov_2r6760kwee.f[7]++;

        var _ref3 = (cov_2r6760kwee.s[20]++, this.props),
            groupBy = _ref3.groupBy,
            data = _ref3.data,
            props = _objectWithoutProperties(_ref3, ["groupBy", "data"]);

        cov_2r6760kwee.s[21]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            data: this.state.data,
            groupKey: this.groupKey,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 57,
              columnNumber: 14
            }
          }))
        );
      }
    }]);

    return Group;
  }(React.Component), _class.defaultProps = {
    data: []
  }, _temp;
});